import { ReactNode } from 'react';
import { Dropdown, type DropdownItemProps } from '../Dropdown/Dropdown';
import { AccountBalanceSection } from './AccountBalanceSection';
import styles from './AvatarDropdown.module.css';

interface AvatarDropdownUIProps {
  className?: string;
  avatarTrigger?: ReactNode;
  profilePictureUrl?: string;
  onProfileClick?: () => void;
  onPricingClick?: () => void;
  onBillingClick?: () => void;
  onBrandKitsClick?: () => void;
  onIntegrationsClick?: () => void;
  onSettingsClick?: () => void;
  onSignOutClick?: () => void;
}

export const AvatarDropdownUI = ({ 
  className,
  avatarTrigger,
  profilePictureUrl,
  onProfileClick,
  onBillingClick,
  onBrandKitsClick,
  onIntegrationsClick,
  onSettingsClick,
  onSignOutClick
}: AvatarDropdownUIProps) => {
  const menuItems: DropdownItemProps[] = [
    {
      id: 'profile',
      ...(profilePictureUrl ? { iconSvg: profilePictureUrl } : { icon: 'account-circle-fill' }),
      label: 'Profile',
      onClick: onProfileClick || (() => {})
    },
    {
      id: 'billing',
      icon: 'bank-card',
      label: 'Billing',
      onClick: onBillingClick || (() => {})
    },
    // Between Billing and Integrations: a brand kit is account-level, like a plan, not a per-deck setting.
    {
      id: 'brand-kits',
      icon: 'brand-kit',
      label: 'Brand Kits',
      onClick: onBrandKitsClick || (() => {})
    },
    {
      id: 'integrations',
      icon: 'Integrations',
      label: 'Integrations',
      onClick: onIntegrationsClick || (() => {})
    },
    {
      id: 'settings',
      icon: 'settings',
      label: 'Settings',
      onClick: onSettingsClick || (() => {})
    },
    // Set Sign Out apart from the navigation items with a divider, styled like a normal (non-destructive) item.
    {
      id: 'signout-separator',
      separator: true,
      label: ''
    },
    {
      id: 'signout',
      icon: 'logout-box-r',
      label: 'Sign Out',
      onClick: onSignOutClick || (() => {})
    }
  ];

  const defaultAvatar = (
    <div className={styles.defaultAvatar}>
      U
    </div>
  );

  return (
    <Dropdown
      trigger={avatarTrigger || defaultAvatar}
      items={menuItems}
      headerContent={<AccountBalanceSection />}
      align="end"
      width={240}
      sideOffset={8}
      // A touch more breathing room below Sign Out than the default 4px panel padding.
      contentStyle={{ paddingBottom: 'var(--spacing-8)' }}
    />
  );
};

